import React, { FC } from 'react';
import { Text } from '@blueprint/ui';
import { Link } from '@blueprint/link';

import {
    MenuButton,
    LogoWrapper,
    HamburgerWrapper,
    HamburgerSpan,
    StyledZooplaLogo,
    MobileActionsWrapper,
    StyledUserIcon,
    ActionWithLabelButton,
    MobileLinksWrapper
} from './LogoMenu.styles';
import ProfileMenu from '../ProfileMenu';
import { PropertiesSmall, SaveOutlineSmall } from '@blueprint/icons';

type Props = {
    signInUrl: string;
};

const LogoMenu: FC<Props> = ({ signInUrl }) => (
    <LogoWrapper>
        <Link
            href="/"
            aria-label="Zoopla"
            data-testid="header-logo"
            data-ajax="false"
        >
            <StyledZooplaLogo />
        </Link>
        <MobileActionsWrapper>
            <MenuButton
                aria-label="Main menu"
                data-testid="header-mobile-hamburger"
                data-universal-header-hamburger-button
                data-track-category="navbar"
                data-track-action="click"
                data-track-label="open burger"
                aria-expanded="false"
            >
                <HamburgerWrapper>
                    <HamburgerSpan />
                    <HamburgerSpan />
                    <HamburgerSpan />
                </HamburgerWrapper>
                <Text data-id="open-button">Menu</Text>
                <Text data-id="close-button">Close</Text>
            </MenuButton>
            <MobileLinksWrapper>
                <ActionWithLabelButton
                    href="/home-values/"
                    variant="tertiary"
                    data-testid="header-mobile-my-home"
                    data-header-signin="/home-values/"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>my home"
                    data-ajax="false"
                    data-myhome-button
                >
                    <PropertiesSmall />
                    <Text>My Home</Text>
                </ActionWithLabelButton>
                <ActionWithLabelButton
                    href="/favourites/properties/"
                    variant="tertiary"
                    data-testid="header-mobile-saved"
                    data-header-signin="/favourites/properties/"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>favourite properties"
                    data-ajax="false"
                >
                    <SaveOutlineSmall />
                    <Text>Saved</Text>
                </ActionWithLabelButton>
                <ActionWithLabelButton
                    href={signInUrl}
                    variant="tertiary"
                    data-testid="header-mobile-sign-in"
                    data-header-signin="/signin/?page_after_login={URL}&return_url={URL}"
                    data-track-category="User Account"
                    data-track-action="clickthrough"
                    data-track-label="user account>sign in"
                    data-is-logged-in="false"
                    data-ajax="false"
                >
                    <StyledUserIcon width="20px" height="20px" />
                    <Text>Sign in</Text>
                </ActionWithLabelButton>
            </MobileLinksWrapper>
        </MobileActionsWrapper>
        <ProfileMenu signInUrl={signInUrl} />
    </LogoWrapper>
);

export default LogoMenu;
